module.exports = __webpack_public_path__ + "img/world-bottom-right.ac94c2a0.png";